/**
 * Converts a data URL to a File object using fetch.
 *
 * @param url - The URL of the data to be converted.
 * @param fileName - The name of the file to be created.
 * @param mimeType - The MIME type of the file to be created.
 * @returns A Promise that resolves with the created File object.
 */
export const dataUrlToFileUsingFetch = async (
  url: string,
  fileName: string,
  mimeType: string,
) => {
  const response = await fetch(url);
  const buffer = await response.arrayBuffer();

  return new File([buffer], fileName, { type: mimeType });
};
